export default __webpack_public_path__ + "static/media/aboutBg2.b9c51741.png";